import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { BreadcrumbPath, BreadcrumbProps } from "../models/BreadcrumbModels";
import { useTranslation } from "react-i18next";
import { AuthenticationContext } from "../../../shared/Contexts";
import { useContext } from "react";

export const Breadcrumb = (props: BreadcrumbProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { authUserDetails } = useContext(AuthenticationContext);
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      className="my-3"
    >
      {props?.isFromOPVA ? (
        <Typography key={"OPVA"} color="text.secondary">
          {authUserDetails?.organizationName}
        </Typography>
      ) : (
        <Link underline="none" key="home" onClick={(e) => navigate("/home")}>
          {authUserDetails?.organizationName}
        </Link>
      )}
      {props.pathList &&
        props.pathList.length > 0 &&
        props.pathList.map(
          (
            data: BreadcrumbPath,
            index: number,
            sourceList: BreadcrumbPath[]
          ) => {
            return index + 1 === sourceList.length ? (
              <Typography key={data.name} color="text.primary">
                {data.name}
              </Typography>
            ) : data.isLink ? (
              <Link
                underline="none"
                key={data.name}
                color="text.primary"
                onClick={(e) => navigate("/" + data.path)}
              >
                {data.name}
              </Link>
              
            ) : (
              <Typography key={data.name} color="text.primary">
                {data.name}
              </Typography> 
            );
          }
        )}
    </Breadcrumbs>
  );
};
